import React from "react";
import { SideMenu, Model, DateRangePicker } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Countries from "./../../../data/countries";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { BsFillChatDotsFill } from "react-icons/bs";
import { HiOutlineUpload } from "react-icons/hi";
import { IoMdAnalytics } from "react-icons/io";
import { useAlert } from "react-alert";
import { useNavigate } from "react-router-dom";
import "./tutor.css";
const Tutor = () => {
  const navigate = useNavigate();
  const alert = useAlert();
  const [invite, setInvite] = React.useState(false);
  const EditHander = (e) => {
    if (e.target.value === "Edit") {
      navigate("/tutor/add", {
        state: { type: "edit" },
      });
    }
  };
  const State = [
    {
      title: "Balochistan",
    },
    {
      title: "Punjab",
    },
    {
      title: "Sindh",
    },
    {
      title: "KPK",
    },
  ];
  const [TableData, setTableData] = React.useState([
    {
      date: "JAN 4, 2022",
      tutorName: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
      role: "Maths",
      status: "Active",
    },
    {
      date: "JAN 4, 2022",
      tutorName: "Henry O'Brien",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "HenryOBrien@gmail.com",
      phone: "1234567890",
      role: "English",
      status: "Active",
    },
    {
      date: "JAN 4, 2022",
      tutorName: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
      role: "Science",
      status: "Deactive",
    },
    {
      date: "JAN 4, 2022",
      tutorName: "Henry O'Brien",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "HenryOBrien@gmail.com",
      phone: "1234567890",
      role: "English",
      status: "Active",
    },
    {
      date: "JAN 4, 2022",
      tutorName: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
      role: "Science",
      status: "Deactive",
    },
    {
      date: "JAN 4, 2022",
      tutorName: "Henry O'Brien",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "HenryOBrien@gmail.com",
      phone: "1234567890",
      role: "English",
      status: "Active",
    },
    {
      date: "JAN 4, 2022",
      tutorName: "Willow Anderson",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
      role: "Science",
      status: "Deactive",
    },
  ]);
  const handleStatusDropdownChange = (event, tableIndex) => {
    TableData[tableIndex].status = event.target.value;
    setTableData([...TableData]);
  };

  //Invite Tutor
  const [inviteTurorName, setInviteTutorName] = React.useState("");
  const [inviteTurorEmail, setInviteTutorEmail] = React.useState("");
  const [inviteTutorLoading, setInviteTutorLoading] = React.useState(false);
  const inviteTurorNameRef = React.useRef();
  const inviteTurorEmailRef = React.useRef();
  const InviteTutorHandler = () => {
    if (inviteTurorName === "") {
      alert.error(<div className="alert-message">name required</div>);
      inviteTurorNameRef.current.focus();
    } else if (inviteTurorEmail === "") {
      alert.error(
        <div className="alert-message">please enter valid email address</div>
      );
      inviteTurorEmailRef.current.focus();
    } else {
      setInviteTutorLoading(true);
      const InviteTurorObject = {
        name: inviteTurorName,
        email: inviteTurorEmail,
      };
      alert.success(
        <div className="alert-message">you have successfully invited</div>
      );
      console.log(InviteTurorObject);
      setTimeout(() => {
        setInvite(false);
        setInviteTutorLoading(false);
      }, 2000);
    }
  };
  return (
    <SideMenu>
      <div className="page-container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}></Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <Button
                className="header-button"
                variant="text"
                onClick={() => setInvite(true)}
              >
                <p className="page-header-button-text">Invite tutor</p>
              </Button>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <Button className="header-button" variant="text">
                <HiOutlineUpload />{" "}
                <p className="page-header-button-text"> Upload file</p>
              </Button>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <Button
                className="header-button"
                variant="text"
                onClick={() => {
                  navigate("/tutor/add", {
                    state: { type: "add" },
                  });
                }}
              >
                <p className="page-header-button-text">Add Tutor</p>
              </Button>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={7} xs={12}>
              <div>
                <p className="header-input-heading">Search by course Name</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by course Name"
                />
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={5} xs={12}>
              <div>
                <p className="header-input-heading">Role</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search By Role"
                />
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">Country</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  {Countries.map((countriesValue, countriesIndex) => {
                    return (
                      <option key={countriesIndex} value={countriesValue.name}>
                        {countriesValue.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">State</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  {State.map((stateValue, stateIndex) => {
                    return (
                      <option key={stateIndex} value={stateValue.title}>
                        {stateValue.title}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">City</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  {State.map((stateValue, stateIndex) => {
                    return (
                      <option key={stateIndex} value={stateValue.title}>
                        {stateValue.title}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">Status</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  <option value="Complated">Complated</option>
                  <option value="Rejected">Rejected</option>
                </select>
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
              <DateRangePicker />
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={2} xs={12}>
              <Button className="header-apply-button" variant="text">
                <p className="header-apply-button-text">Apply</p>
              </Button>
            </Grid>
            <Grid item xl={7} lg={7} md={6} sm={6} xs={12}></Grid>
          </Grid>
        </Box>
        <br />
        <div className="table-container">
          <div className="table-header">
            <p className="table-heading">Tutors</p>
          </div>
          <div className="table-data-container">
            <table>
              <thead>
              <tr>
                <th className="tutor-table-date-heading">Date</th>
                <th className="tutor-table-turor-name-heading">Tutor Name</th>
                <th className="tutor-table-branch-country-heading">country</th>
                <th className="tutor-table-branch-state-heading">state</th>
                <th className="tutor-table-branch-city-heading">city</th>
                <th className="tutor-table-branch-email-heading">Email</th>
                <th className="tutor-table-branch-phone-number-heading">
                  Phone
                </th>
                <th className="tutor-table-branch-role-heading">Role</th>
                <th className="tutor-table-branch-status-heading">Status</th>
                <th className="tutor-table-branch-chat-heading">Chat</th>
                <th className="tutor-table-branch-action-heading"></th>
                <th className="tutor-table-branch-analytics-heading"></th>
              </tr>
              </thead>
              {TableData.map((tableValue, tableIndex) => {
                return (
                  <tr key={tableIndex}>
                    <td className="table-date-data">{tableValue.date}</td>
                    <td className="table-data">{tableValue.tutorName}</td>
                    <td className="table-data">{tableValue.country}</td>
                    <td className="table-data">{tableValue.state}</td>
                    <td className="table-data">{tableValue.city}</td>
                    <td className="table-email-data">{tableValue.email}</td>
                    <td className="table-data">{tableValue.phone}</td>
                    <td className="table-data">{tableValue.role}</td>
                    <td className="table-data">
                      <select
                        className="table-status-dropdown"
                        style={{
                          backgroundColor:
                            tableValue.status === "Deactive"
                              ? "#FFB0B0"
                              : "#D2FFEB",
                          color:
                            tableValue.status === "Deactive"
                              ? "#B80000"
                              : "#098B51",
                        }}
                        onChange={(e) =>
                          handleStatusDropdownChange(e, tableIndex)
                        }
                      >
                        <option
                          value="Active"
                          selected={
                            tableValue.status === "Active" && "selected"
                          }
                        >
                          Active
                        </option>
                        <option
                          value="Deactive"
                          selected={
                            tableValue.status === "Deactive" && "selected"
                          }
                        >
                          Deactive
                        </option>
                      </select>
                    </td>
                    <td className="table-data">
                      <Button
                        className="table-analytics-chat-button"
                        onClick={() => navigate("/chat")}
                      >
                        <BsFillChatDotsFill color="#663399" size={20} />
                      </Button>
                    </td>
                    <td className="table-data">
                      <select
                        className="table-action-dropdown"
                        onChange={EditHander}
                      >
                        <option value="">Action</option>
                        <option value="Edit">Edit</option>
                        <option value="Delete">Delete</option>
                      </select>
                    </td>
                    <td className="table-data">
                      <Button
                        className="table-analytics-chat-button"
                        onClick={() => navigate("/tutor/analytics")}
                      >
                        <IoMdAnalytics color="#663399" size={20} />
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
          <div className="table-pagination-main">
            <Stack spacing={2}>
              <Pagination count={10} variant="outlined" shape="rounded" />
            </Stack>
          </div>
        </div>
      </div>
      <Model
        modelTitle="Invite tutor"
        width="md"
        onClose={() => setInvite(false)}
        open={invite}
        buttonTitle="invite send"
        buttonHandler={InviteTutorHandler}
        loading={inviteTutorLoading}
      >
        <div className="form-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Name</p>
                  <input
                    type="text"
                    name="fullName"
                    className="input"
                    placeholder="Name"
                    value={inviteTurorName}
                    ref={inviteTurorNameRef}
                    onChange={(e) => setInviteTutorName(e.target.value)}
                  />
                </div>
              </Grid>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Email Address</p>
                  <input
                    type="email"
                    name="email"
                    className="input"
                    placeholder="Email Address"
                    value={inviteTurorEmail}
                    ref={inviteTurorEmailRef}
                    onChange={(e) => setInviteTutorEmail(e.target.value)}
                  />
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>
    </SideMenu>
  );
};
export default Tutor;
